import { createFileRoute } from '@tanstack/react-router';
import ObjectTypeGuidePage from '@/pages/workspaces/objects/object-type-guide.page';
import { ObjectsRoute } from '@/pages/workspaces/objects/routing';
import { RumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/guide')({
  component: () => (
    <ObjectsRoute>
      <RumPageRendered>
        <ObjectTypeGuidePage />
      </RumPageRendered>
    </ObjectsRoute>
  ),
});
